import { jsx } from 'react/jsx-runtime';
import { Loading, NoPermissionBlock } from '@geit/ui-components';
import { useCallback } from 'react';
import '../context/AuthenticationProvider.js';
import useAppModule from '../hooks/useAppModule.js';
import { useCurrentUser } from '../hooks/useCurrentUser.js';
import { usePermission, isOwnRecord } from '../hooks/usePermission.js';
import 'qs';
import 'uuid';
import '../navigate.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function withBaseEmpowerPermission(Component, permissionTypeSource, pathParamHandler) {
  return function (props) {
    var _a;
    const {
      user: currentUser
    } = useCurrentUser();
    const {
      currentFeature
    } = useAppModule();
    const feature = (permissionTypeSource == null ? void 0 : permissionTypeSource.feature) || currentFeature;
    if (!feature) {
      throw new Error("No feature code found!");
    }
    const {
      userPermission,
      isLoading
    } = usePermission(feature, void 0, false, getPermissionParamValues(permissionTypeSource, (_a = currentUser == null ? void 0 : currentUser.entitySelection) == null ? void 0 : _a.refNumber, pathParamHandler));
    const getUserPermission = useCallback(createdBy => {
      let ownRecord = !!createdBy && isOwnRecord(createdBy, currentUser);
      const featurePermission = userPermission == null ? void 0 : userPermission.featurePermission;
      return {
        canCreate: featurePermission.create,
        canDelete: featurePermission.deleteAll || ownRecord,
        canModify: featurePermission.modifyAll || ownRecord,
        canView: featurePermission.viewAll || ownRecord || featurePermission.create && !createdBy,
        featurePermission
      };
    }, [currentUser, userPermission]);
    if (isLoading) {
      return /* @__PURE__ */jsx(Loading, {});
    }
    if (!(userPermission == null ? void 0 : userPermission.canView)) {
      return /* @__PURE__ */jsx(NoPermissionBlock, {});
    }
    const compProps = __spreadProps(__spreadValues({}, props), {
      getUserPermission
    });
    return /* @__PURE__ */jsx(Component, __spreadValues({}, compProps));
  };
}
const getPermissionParamValues = (permissionTypeSource, selectedBrn, pathParamHandler) => {
  if (permissionTypeSource) {
    const {
      brn,
      ban,
      serviceNumber,
      product
    } = permissionTypeSource;
    const urlParams = new URLSearchParams(window.location.search);
    const permissionType = {
      // give the flexibility to get the selected brn from context
      brn: brn === "CONTEXT" ? selectedBrn : getPermissionParamValue(brn, urlParams, pathParamHandler),
      ban: getPermissionParamValue(ban, urlParams, pathParamHandler),
      serviceNumber: getPermissionParamValue(serviceNumber, urlParams, pathParamHandler),
      product: getPermissionParamValue(product, urlParams, pathParamHandler)
    };
    return permissionType;
  }
};
const getPermissionParamValue = (paramSource, searchParams, pathParamHandler) => {
  if (typeof paramSource === "object") {
    if (paramSource.queryParam) {
      return searchParams.get(paramSource.queryParam) || void 0;
    } else if (paramSource.pathParam) {
      return pathParamHandler == null ? void 0 : pathParamHandler(paramSource.pathParam);
    }
  } else {
    return paramSource;
  }
};
export { withBaseEmpowerPermission as default };